import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal.tsx';
import { useModal } from 'components/modals/useModal.ts';
import { useDeleteJobRoleMutation } from 'store/api/jobRoles';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/**
 * Opens the job role's delete confirmation; once deleted, `onDeleted` runs and the page leaves the record. The edit
 * form and the record header both offer it.
 */
export const useDeleteJobRole = (jobRoleId: string | undefined, onDeleted?: () => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteJobRole] = useDeleteJobRoleMutation();
    const leaveDeleted = useLeaveDeletedEntity('/job-roles');

    return () => {
        if (!jobRoleId || isNaN(Number(jobRoleId))) {
            return;
        }
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteJobRole({ id: jobRoleId })
                        .unwrap()
                        .then(() => {
                            onDeleted?.();
                            leaveDeleted();
                        })
                        .catch(console.error)
                        .finally(() => closeModal());
                }}
                content={t('job-roles.delete-confirmation-text')}
            />
        );
    };
};
